import Memos from './Memos';

export default Memos;
